import React from 'react';
import ReactDOM from 'react-dom';

import QuoteGenerator from "./components/QuoteGenerator";
import './App.css';

ReactDOM.render(<QuoteGenerator />, document.getElementById('root'));